// The enums are set as strings because the first key defaults to zero. Which can lead to annoying validation issues.
export enum TeamOption {
  HOME = 'home',
  AWAY = 'away',
}
